import { Table } from 'components/Table'
import '../styles.scss'
import { columns } from '../constants'
import { TCommonTableData } from '../types'
import { TPageInfo } from '../../../components/Table/types'
import { useSelector } from 'react-redux'
import { getUser } from 'redux/store/user/getters'
import { ACTIONS, dashboardSubject, SUBJECTS } from '../Abilities'
import { useDashboardAbility } from '../Providers/DashboardAbilityProvider'

type DashboardTableProps = {
  tableData: TCommonTableData[]
  firstLoad: boolean
  totalNumber: number
  pageInfo: TPageInfo
  onTableChange: (pagination, filters, sorter) => void
  onChangePageSize: (pageSize: number) => void
}

export const DashboardTable = ({
  tableData,
  firstLoad,
  totalNumber,
  pageInfo,
  onTableChange,
  onChangePageSize
}: DashboardTableProps) => {
  const ability = useDashboardAbility()
  const user = useSelector(getUser)
  const canSeeHealthSystem = ability.can(
    ACTIONS.VIEW,
    dashboardSubject(SUBJECTS.HEALTH_SYSTEM_COLUMN, user)
  )

  return (
    <div className="table-wrapper table-wrapper_collapse-top-margin">
      {!firstLoad && (
        <Table<TCommonTableData>
          dataSource={tableData}
          className="dashboard-table"
          columns={columns(canSeeHealthSystem)}
          onChange={onTableChange}
          onChangePage={onChangePageSize}
          pageSize={pageInfo.pageSize}
          pagination={{
            pageSize: pageInfo.pageSize,
            current: pageInfo.pageNumber,
            total: totalNumber
          }}
        />
      )}
    </div>
  )
}
